import React, {useEffect, useState} from "react";
import { AuthContext } from "./AuthContext";
import {useDispatch, useSelector} from "react-redux";
import {selectStore, RootState} from "../../store";
import {Cookies, useCookies} from "react-cookie";
import {COOKIE_KEY} from "../../constants";
import {fetchAuth} from "../../store/pages/profile";
import { useEmbeddedNavigate } from "../embed";

const cookies = new Cookies();

interface AuthProviderProps {
  children: React.ReactNode
}

export const setTokenCookie = (token: string | null) => {
  cookies.set(COOKIE_KEY.ACCESS_TOKEN, token, {path: '/'})
}

export const setScreeningCookie = (token: string | null) => {
  cookies.set(COOKIE_KEY.IS_SCREENING, token, {path: '/'})
}

export const setRefreshTokenCookie = (token: string | null) => {
  cookies.set(COOKIE_KEY.REFRESH_TOKEN, token, {path: '/'})
}

export const setEmbedTokenCookie = (token: string | null) => {
  cookies.set(COOKIE_KEY.EMBED, token, {path: '/'})
}

export const getTokenCookie = (): string | null => {
  return cookies.get(COOKIE_KEY.ACCESS_TOKEN) || null;
};

export const getRefreshTokenCookie = (): string | null => {
  return cookies.get(COOKIE_KEY.REFRESH_TOKEN) || null;
};

export const removeTokenCookie = () => {
  cookies.remove(COOKIE_KEY.ACCESS_TOKEN, {path: '/'})
  cookies.remove(COOKIE_KEY.LANG, {path: '/'})
  cookies.remove(COOKIE_KEY.THEMES, {path: '/'})
  cookies.remove(COOKIE_KEY.IS_SCREENING, {path: '/'})
}

export const AuthProvider: React.FC<AuthProviderProps> = ({children}) => {
  const dispatch = useDispatch()
  const [cookie] = useCookies([COOKIE_KEY.ACCESS_TOKEN])

  const {profile: {userProfile: userProfileState}}: RootState = useSelector(selectStore)

  const [isAuth, setIsAuth] = useState<boolean>(!!cookie[COOKIE_KEY.ACCESS_TOKEN]);
  const [role, setRole] = useState<string>('')

  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    if (userProfileState.success) {
      setRole(userProfileState.data?.person_type)
    }
  }, [userProfileState.success])

  useEffect(() => {

    const cookiesHandler = (options: any) => {
      if (options.name === COOKIE_KEY.ACCESS_TOKEN) {
        if (options.value !== undefined) {
          setIsAuth(true)
        } else {
          setIsAuth(false)
        }
      }
    }

    cookies.addChangeListener((options) => {
      cookiesHandler(options)
    })

    return () => {
      cookies.removeChangeListener((options) => {
        cookiesHandler(options)
      })
    }
  }, [cookie])

  const handleLogin = async (values: any) => {
    dispatch(fetchAuth(values))
  };


  const handleLogout = async () => {
    removeTokenCookie()
  };


  const value = {
    isAuth, handleLogin, handleLogout, role
  }

  return (
    <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
  );
}
